<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>

		<a-form layout="inline">
			<a-form-item label="话术关键词">
				<a-input v-model="filterData.keywords" placeholder="请输入话术关键词" />
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>
				<a-button v-if="filterData.lang === 'CH'" @click="toAdd" type="primary">添加话术</a-button>
			</a-form-item>
		</a-form>

		<div style="margin-top: 16px;margin-bottom: 16px;">
			<a-radio-group v-model="filterData.templateType" button-style="solid" @change="changeTab">
				<!-- 循环后端tags数组，动态生成单选按钮 -->
				<a-radio-button style="width: 150px;text-align: center;" v-for="item in tags" :key="item.tagId" :value="item.tagId">
					{{ item.tagName }}
				</a-radio-button>
			</a-radio-group>
		</div>



		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<!-- 执行状态 -->
			<!-- ACTIVE-现行有效 PENDING-即将实施 OBSOLETE-已废止 -->
			<template slot="templateTypeRender" slot-scope="text, record">
				<div color="green" v-if="record.templateType == 'TO_REPORTER'">
					回复举报人
				</div>
				<div color="#afa" v-else-if="record.templateType == 'TO_TARGET'">
					回复被举报人
				</div>
				<div color="#898989" v-else-if="record.templateType == 'TO_FEEDBACK'">
					回复意见反馈
				</div>
				<div v-else></div>
			</template>
			<!-- 发布状态 1 2-->
			<!-- <template slot="standardStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.standardStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="green" v-if="record.standardStatus == true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" color="#898989" v-else-if="record.standardStatus == false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>

			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template> -->
			<!-- 编辑，删除 -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<span><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm v-if="filterData.lang === 'CH'" title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link">删除</a-button>
					</a-popconfirm>
				</div>
			</template>

		</a-table>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<!-- :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" -->
			<a-form-model ref="formRef" :model="editModel" :rules="rules">

				<!-- 第四行：实施日期 + 状态 -->
				<a-row :gutter="20">
					<a-col :span="12">
						<a-form-model-item label="类别" prop="templateType">
							<a-select v-model="editModel.templateType" placeholder="请选择话术类别">
								<a-select-option value="TO_REPORTER">回复举报人</a-select-option>
								<a-select-option value="TO_TARGET">回复被举报人</a-select-option>
								<a-select-option value="TO_FEEDBACK">回复反馈意见</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 第二行：标准名称 通栏 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="话术内容" prop="templateContent">
							<a-textarea v-model="editModel.templateContent" placeholder="请输入话术内容（10~100 个字符）" />
						</a-form-model-item>
					</a-col>
				</a-row>


			</a-form-model>
		</a-modal>


		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>底部内容</div>
			<div><a-input v-model.number="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-input v-model.number="tipsModel.bottomContent" placeholder="内容" /></div>
		</a-modal>

	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		 getReplyTemplateListApi, //  执行标准列表
		editReplyTemplateApi, //  执行标准新增/编辑
		deleteReplyTemplateApi, //    执行标准删除
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'], // 颜色功能在这里
							['clean']

						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				commodityStatusList: [{
						label: "现行有效",
						value: 'ACTIVE',
					},
					{
						label: "即将实施",
						value: 'PENDING',
					},
					{
						label: "已废止",
						value: 'OBSOLETE',
					},
				],
				columns: [{
						title: '序号',
						dataIndex: 'templateId',
						key: 'templateId',
					},
					{
						title: '回复类型',
						dataIndex: 'templateType',
						key: 'templateType',
						scopedSlots: {
							customRender: 'templateTypeRender'
						},
					},
					{
						title: '话术详情',
						dataIndex: 'templateContent',
						key: 'templateContent',
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					bottomTitle: "",
					bottomContent: "",
					type: 'STANDAR',
					onOk: () => {},
				},
				rules: {
				templateContent: [
					{ required: true, message: '请输入话术内容', trigger: 'blur' }
				]
			},
			editModel: {
					flag: false,
					title: "",
					templateId: 0,
					keywords:"",
					templateType: undefined,
					templateContent: '',
					lang:"CH",
					onOk: () => {},
				},
				rules: {
					templateContent: [
						{ required: true, message: '请输入话术内容', trigger: 'blur' }
					]
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: "",
					templateType: "TO_REPORTER",
					lang: "CH",
				},
				tags: [
					{tagId:'TO_REPORTER',tagName:"回复举报人"},
					{tagId:'TO_TARGET',tagName:"回复被举报人"},
					{tagId:'TO_FEEDBACK',tagName:"回复意见反馈"}
				],
				deptText: "",
				deptList: [],
				mainText: "",
				mainList: [],
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('serviceScriptMng_searchQuery1');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {
				this.filterData.templateType = "TO_REPORTER";
			}
			console.log(this.filterData)
			this.getData(1)
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('serviceScriptMng_searchQuery1', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},

			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			initDragBrand1() {
				const el = this.$refs.dragContainerBrand
				if (!el) return
				this.sortable = Sortable.create(el, {
					animation: 150, // 流畅动画
					handle: '.size_item', // 可拖拽元素
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						const {
							oldIndex,
							newIndex
						} = evt
						// 数组顺序同步（核心！）
						const moveItem = this.deptList.splice(oldIndex, 1)[0]
						this.deptList.splice(newIndex, 0, moveItem)
					},
				})
			},
			deleteDept(index) {
				this.deptList.splice(index, 1);
			},
			addDept() {
				if (!this.deptText) return;
				this.deptList.push(this.deptText);
				this.deptText = '';
			},
			initDragBrand2() {
				const el = this.$refs.dragContainerMain
				if (!el) return
				this.sortable = Sortable.create(el, {
					animation: 150, // 流畅动画
					handle: '.size_item', // 可拖拽元素
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						const {
							oldIndex,
							newIndex
						} = evt
						// 数组顺序同步（核心！）
						const moveItem = this.mainList.splice(oldIndex, 1)[0]
						this.mainList.splice(newIndex, 0, moveItem)
					},
				})
			},
			deletemain(index) {
				this.mainList.splice(index, 1);
			},
			addMain() {
				if (!this.mainText) return;
				this.mainList.push(this.mainText);
				this.mainText = '';
			},
			handleCategoryChange() {
				// 切换分类后，重置页码并刷新表格
				this.pageInfo.current = 1;
				this.loadTableData();
			},
			handleSwitch(checked) {
				this.editModel.standardStatus = checked
			},


			handleBlur() {
			},
			handleFocus() {
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData.keywords = "";
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getReplyTemplateListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						templateType: this.filterData.templateType,
						keywords: this.filterData.keywords,
						lang: this.filterData.lang,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.records || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.$nextTick(() => {
					this.$refs.formRef && this.$refs.formRef.clearValidate()
				})
				this.editModel = {
					flag: true,
					title: "新增",
					templateId: 0,
					templateType: this.filterData.templateType,
					templateContent: '',
					lang:"CH",
					sort: this.pageInfo.total + 1,
					onOk: this.sureEdit,
				};
			},
			toEdit(data) {
				this.$nextTick(() => {
					this.$refs.formRef && this.$refs.formRef.clearValidate()
				})
				this.editModel = {
					flag: true,
					title: "修改",
					templateId: data.templateId,
					templateType: data.templateType,
					templateContent: data.templateContent,
					lang:this.filterData.lang,
					sort: this.pageInfo.total + 1,
					onOk: this.sureEdit,
				};

			},
			confirm() {

			},
			sureScript(data) {
			},
			// 话术编辑
			// scriptEdit() {
			// 	this.tipsModel = {
			// 		flag: true,
			// 		title: "执行标准页面话术编辑",
			// 		templateId:0,
			// 		templateType: undefined,
			// 		templateContent: "",
			// 		onOk: this.sureScript,
			// 	};
			// },
			sureEdit(data) {
				this.$refs.formRef.validate(valid => {
				if (!valid) return
				editReplyTemplateApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						templateId: this.editModel.templateId || 0,
						templateType:this.editModel.templateType,
						templateContent:this.editModel.templateContent,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.templateId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
						}
					})
					.catch((error) => {
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
			})
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				deleteReplyTemplateApi({
						templateId: record.templateId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
						} else {
						}
					})
					.catch((error) => {
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传文件
			handleUploadThumbnail(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						ossUpload(file, '', 'pdf/').then((res) => {
							this.editModel.standardDocument = res.url;
						}).catch(err => {
							this.$message.error('图片上传失败')
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		/* 改为固定高度，不要 min-height */
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
</style>
